<template>
    <v-text-field
            v-if="!!text"
            :hint="hint"
            ref="textCopier"
            @click.stop=""
            @focus="$event.target.select()"
            :label="label"
            :value="text"
            readonly fillled
            dense
            append-icon="far fa-copy"
            @click:append="copy"
    />
</template>

<script>
    import {mapMutations} from 'vuex'
    export default {
        props:{
            text: {
                type: String,
                default: ''
            },
            label:{
                type: String,
                default: 'Texto a copiar'
            }
        },
        data(){
            return {
                hint: ''
            }
        },
        methods:{
            ...mapMutations(['showSnackBar']),
            copy(){
                var vm = this
                vm.$refs.textCopier.focus()
                document.execCommand("copy");
                vm.showSnackBar({
                    text:'¡Copiado!',
                    color: 'info'
                })
            }
        }
    }
</script>

<style scoped>

</style>
